/*============================================================================
  Image Zoom
==============================================================================*/
class ImageZoom extends HTMLElement {
    constructor() {        
        super();
        this.container = this.querySelector('.image-zoom');
        this.imgUrl = this.container.getAttribute('data-zoom');
        this.inProgress = false;
        this.img = document.createElement('img');
  
        this.onMove = this.move.bind(this);
        this.onImgLoad = this.load.bind(this);
        
        this.init();
  
        this.containerWidth = this.container.offsetWidth;
        this.containerHeight = this.container.offsetHeight;        
  
        this.container.addEventListener('mouseenter', this.start.bind(this));
        this.container.addEventListener('mouseleave', this.stop.bind(this));
    }
  
    init() {
        this.img.classList.add('zoomedImage');                        
        this.img.style.position = 'absolute';
        this.img.style.top = 0;
        this.img.style.left = 0;
        this.img.style.width = 'auto';
        this.img.style.height = 'auto';
        this.img.style.maxWidth = 'none';
        this.img.style.maxHeight = 'none';
        this.img.style.display = 'none';       
    }
  
    start() {
        if (window.innerWidth < 1024)
            return;

        if (this.inProgress && this.container.querySelector('.zoomedImage'))
            return;
        
        var $this = this;        
        this.inProgress = true;      
  
        this.container.style.overflow = 'hidden';
        this.container.style.position = 'relative';
  
        if (!this.container.querySelector('.zoomedImage')) {            
            this.img.src = this.imgUrl;
  
            this.img.onload = function (e) {                
                $this.onImgLoad();
            };            
            this.container.appendChild(this.img);                        
        } else {            
            this.img.style.display = 'block';
        }
        
        document.body.addEventListener('mousemove', this.onMove);
    }
    
    load() {        
        this.img.style.display = 'block';
    }
        
    move(e) {
        var rect = this.container.getBoundingClientRect();
  
        var offset = {
            top: rect.top + document.body.scrollTop,
            left: rect.left + document.body.scrollLeft
        }    
  
        var left = (e.pageX - offset.left),
            top = (e.pageY - offset.top);
  
        top = Math.max(Math.min(top, this.img.height), 0);
        left = Math.max(Math.min(left, this.img.width), 0);
        
        var xRatio = (this.img.width - this.containerWidth) / this.img.width;
        var yRatio = (this.img.height - this.containerHeight) / this.img.height;
        
        this.img.style.left = (left * -xRatio) + 'px';
        this.img.style.top = (top * -yRatio) + 'px';    
    }
  
    stop() {                          
        this.inProgress = false;
        this.img.style.display = 'none';
        document.body.removeEventListener('mousemove', this.onMove);     
    }
  }
  
  customElements.define('image-zoom', ImageZoom);